export const columns = [
	{ id: "name", label: "Ім'я Прізвище" },
	{ id: "friendlyName", label: "Ім'я" },
	{ id: "role", label: "Роль співробітника" },
	{ id: "minorRoles", label: "Другорядні ролі" },
	{ id: "managerId", label: "ID співробітника" },
	{ id: "email", label: "Email" },
	{ id: "readWarehouses", label: "Склади на перегляд" },
	{ id: "writeWarehouses", label: "Склади на редактування" },
	{ id: "tempPassword", label: "Тимчасовий пароль" },
	{ id: "buttons", label: "", minWidth: 65 },
];

export const emptyUser = {
	id: "new-user-id",
	name: "",
	friendlyName: "",
	email: "",
	role: {},
	minorRoles: [],
	tempPassword: "",
	passwordStatus: "TEMPORARY",
};

export const userRolesTranslationConformity = {
	ADMIN: "АДМІН",
	MANAGER: "МЕНЕДЖЕР",
	STOREKEEPER: "КЛАДОВЩИК",
	DRIVER: "ВОДІЙ",
	SERVER1C: "1ССЕРВЕР",
	NP: "Ноша пошта",
};

export const userToWarehouseAccessType = {
	READ: "READ",
	WRITE: "WRITE",
};
